import { Text } from '@vtex/admin-ui'
import React from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import { useSuspenseFragment } from 'react-relay-offline'
import { FormattedMessage, useIntl } from 'react-intl'

import { formatDifferencePercentageBetweenValues } from '../../../../core/utils/percentage'
import { Price } from '../../../../core/components'
import { getBestInstallmentData } from './utils'
import type { PaymentsMethodsListContentBestInstallment_PaymentOption$key } from './__generated__/PaymentsMethodsListContentBestInstallment_PaymentOption.graphql'

const paymentOptionFragment = graphql`
  fragment PaymentsMethodsListContentBestInstallment_PaymentOption on PaymentOption {
    total {
      amount
    }
    ...utils_PaymentOption
  }
`

export type PaymentsMethodsListContentBestInstallmentProps = {
  paymentOptionConnectionRef: PaymentsMethodsListContentBestInstallment_PaymentOption$key
}

export const PaymentsMethodsListContentBestInstallment = ({
  paymentOptionConnectionRef,
}: PaymentsMethodsListContentBestInstallmentProps) => {
  const { formatMessage } = useIntl()

  const paymentOption = useSuspenseFragment(
    paymentOptionFragment,
    paymentOptionConnectionRef
  )

  const bestInstallmentsData = getBestInstallmentData(paymentOption)

  const firstInstallmentHasDiscount =
    bestInstallmentsData.installments[0]?.node.value.amount <
    paymentOption.total.amount

  return (
    <>
      {bestInstallmentsData.installments.length === 1 && (
        <>
          <Text variant="action2">
            <Price
              value={
                bestInstallmentsData.installments[0].node.value.amount / 100
              }
            />
          </Text>
          {firstInstallmentHasDiscount ? (
            <Text variant="detail" tone="positive">
              {' '}
              <FormattedMessage
                id="pdp.payment.installments-drawer.percentage-discount"
                values={{
                  percentage: formatDifferencePercentageBetweenValues(
                    bestInstallmentsData.installments[0].node.value.amount,
                    paymentOption.total.amount,
                    0
                  ),
                }}
              />
            </Text>
          ) : (
            <Text variant="action2">
              {' '}
              <FormattedMessage id="pdp.payment.one-installment-payment" />
            </Text>
          )}
        </>
      )}
      {bestInstallmentsData.installments.length > 1 && (
        <Text variant="action2">
          <FormattedMessage
            id="pdp.payment.best-payment"
            values={{
              installmentsCount: bestInstallmentsData.installments.length,
              value: (
                <Price
                  value={bestInstallmentsData.lastInstallmentValue / 100}
                />
              ),
            }}
          />
          {!bestInstallmentsData.hasInterestRate && (
            <Text variant="action2" tone="positive">
              {' '}
              {formatMessage({ id: 'interestFree' }).toLocaleLowerCase()}
            </Text>
          )}
        </Text>
      )}
    </>
  )
}
